export default __webpack_public_path__ + "static/media/chip.ed58f4e8.svg";